<template>
  <div class="full-width">
    <div class="donation-title-2 mb-10">Type betaling:</div>

    <div class="div-block-47">
      <template v-for="(paymentOption, index) in paymentOptions" :key="index">
        <div
          @click="setValue(paymentOption.id)"
          class="donation-grid-item"
          :class="selectValue == paymentOption.id ? ' active' : ''"
        >
          <img
            :src="paymentOption.image"
            loading="lazy"
            class="donation-grid-item-image"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["initial_value"],
  created() {
    this.selectValue = this.initial_value
  },
  data: () => {
    return {
      paymentOptions: [
        { id: "ideal", name: "iDeal", image: require("@/assets/images/New-Project.png") },
        {
          id: "creditcard",
          name: "creditcard",
          image: require("@/assets/images/donatieschermen-1-3.png"),
        },
        {
          id: "paypal",
          name: "paypal",
          image: require("@/assets/images/donatieschermen-1-2.png"),
        },
      ],
      selectValue: "",
    }
  },
  methods: {
    setValue(id) {
      this.selectValue = id
      this.$store.state.payment_info.payment_option = id
    },
  },
}
</script>

<style scoped>
.donation-grid-item {
  cursor: pointer;
}

.donation-grid-item.active {
  border-color: #3898ec;
  border-width: 3px;
  background-color: #bde0ff;
}
</style>
